(function(){
  const bar  = document.getElementById('gfsb');
  if(!bar) return;
  const txt  = document.getElementById('gfsbText');
  const prog = document.getElementById('gfsbProgress');

  const thresholdEuro = Number(bar.dataset.threshold || '100');
  const THRESHOLD = Math.round(thresholdEuro * 100); // in Cent

  function fmtMoney(cents){
    try { return new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2)+' €'; }
  }
  function pct(total){
    const p = Math.round((total * 100) / THRESHOLD);
    return Math.max(8, Math.min(100, p));
  }

  async function refresh(){
    try{
      const res  = await fetch('/cart.js', { credentials:'same-origin', cache:'no-store' });
      const cart = await res.json();

      if ((cart.item_count || 0) <= 0) { bar.hidden = true; return; }

      // Nach Rabatt rechnen (empfohlen). Vor Rabatt? -> cart.items_subtotal_price
      const total = cart.total_price || 0;
      const remaining = Math.max(0, THRESHOLD - total);

      if (remaining === 0 || total >= THRESHOLD) {
        txt.innerHTML = '<strong>Versandkostenfrei</strong>';
        prog.style.width = '100%';
      } else {
        txt.innerHTML = `Nur noch <strong>${fmtMoney(remaining)}</strong> bis gratis Versand – fast geschafft!.`;
        prog.style.width = pct(total) + '%';
      }
      bar.hidden = false;
    } catch(e){ /* still */ }
  }

  // Initial
  document.addEventListener('DOMContentLoaded', refresh);

  // Generische Events
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('product:added', refresh);

  // Empire-spezifische Varianten (Out of the Sandbox)
  document.addEventListener('pxu:cart:update', refresh);
  document.addEventListener('pxu:cart:change', refresh);

  // Mengenänderung (Cart/Drawer)
  document.addEventListener('change', (e)=>{
    if(e.target && (e.target.name||'').includes('updates')) refresh();
  });

  // Theme-Editor / Section reloads
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);

  // Nach ATC-Submit
  document.querySelectorAll('form[action^="/cart/add"]').forEach(f=>{
    f.addEventListener('submit', ()=>{
      setTimeout(refresh, 700);
      setTimeout(refresh, 1400);
    });
  });

  // Fallback Polling (alle 5s)
  setInterval(refresh, 5000);

  // Beim Tab-Wechsel erneut prüfen
  document.addEventListener('visibilitychange', ()=>{ if(!document.hidden) refresh(); });
})();
